import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=6a28ee04&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28ee04",
  null
  
)

export default component.exports